var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._g(_vm._b({attrs:{"validate-on-blur":"","dense":"","background-color":"'#212121'","color":'#212121',"on-icon":'$checkedCheckbox',"off-icon":'$uncheckedCheckbox'},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},'v-checkbox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }